import { ReactNode } from 'react';

import {
  TradingLeaderboardInterval,
  TradingLeaderboardLeague,
  TradingLeaderboardTier,
} from '@flipster/apis/v2/trading-leaderboards/types';
import { FormattedMessage } from '@flipster/i18n';

export const tradingLeaderboardLeagues: TradingLeaderboardLeague[] = ['NORMAL', 'MASTER'];
export const tradingLeaderboardIntervals: TradingLeaderboardInterval[] = ['WEEKLY', 'MONTHLY'];
export const tradingLeaderboardTiers: TradingLeaderboardTier[] = ['ALL', 'WHALE', 'SHARK', 'STARTER'];

export interface IntervalInformation {
  label: ReactNode;
}
export const intervalInfos: Record<TradingLeaderboardInterval, IntervalInformation> = {
  WEEKLY: {
    label: <FormattedMessage id='Autogen_common.r251126.s_week' />,
  },
  MONTHLY: {
    label: <FormattedMessage id='Autogen_common.r251126.s_month' />,
  },
};

export interface TierInformation {
  label: ReactNode;
}
export const tierInfos: Record<TradingLeaderboardTier, TierInformation> = {
  ALL: {
    label: <FormattedMessage id='Common.r250923.All' />,
  },
  WHALE: {
    label: <FormattedMessage id='Market.r250925.Whale' />,
  },
  SHARK: {
    label: <FormattedMessage id='Market.r250925.Shark' />,
  },
  STARTER: {
    label: <FormattedMessage id='Market.r250925.Starter' />,
  },
};
